import Promise from 'bluebird'
import util from '~/assets/javascripts/util'
import { commonMetaData } from '~/store/_helpers/common-helper'
import grpcClient from '@/grpc/grpc-client'
import { GetUserRequest } from '~/stub/apigateway/profile/user_pb'
import { UserService } from '~/stub/apigateway/profile/user_pb_service'
import { MEASURING_APP_INSTALL } from '~/constants/cookie'

// nuxt.config.jsに書いてもグローバルに効かなかったのでローカルで設定する
Promise.config({ cancellation: true })

export const state = () => ({
  route: null // NOTE: vuex-router-sync用に初期化
})

export const getters = {
  entered: state => state.entered
}

export const actions = {
  async nuxtServerInit(
    { state, getters, dispatch, commit },
    { error, req, redirect, route, query }
  ) {
    await dispatch('auth/setAppId')

    // cookieにccuidがなかったら発行する
    // 開発環境で確認する場合は'secure: true'を外す
    let ccuid = this.$cookies.get(process.env.config['ccuid'])
    if (!ccuid) {
      ccuid =
        new Date().getTime().toString(16) +
        ':' +
        Math.floor(Math.random() * 0xffffffff).toString(16)

      this.$cookies.set('ccuid', ccuid, {
        path: '/',
        maxAge: 60 * 60 * 24 * 365 * 2,
        secure: true
      })
    }

    // パラメータ付きリンク経由キャンペーン用のパラメータの値をCookieにセット
    // 有効期間は7日間で設定
    const campaign = state.route.query.campaign
    if (campaign) {
      this.$cookies.set('via_link_with_param', campaign, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7
      })
    }

    // x-user-agent用のuser-agent取得
    const ua = this.$ua._ua
    // x-forwaded-for用のip取得
    let ip = ''
    if (req.headers && req.headers['x-real-ip']) {
      ip = req.headers['x-real-ip']
    } else if (req.headers && req.headers['x-forwarded-for']) {
      ip = req.headers['x-forwarded-for']
    } else if (req.connection && req.connection.remoteAddress) {
      ip = req.connection.remoteAddress
    } else if (req.connection && req.connection.socket && req.connection.socket.remoteAddress) {
      ip = req.connection.socket.remoteAddress
    } else if (req.socket && req.socket.remoteAddress) {
      ip = req.socket.remoteAddress
    }
    // x-referer用のreferer取得
    let referer = ''
    if (req.headers) {
      if (req.headers.referrer) {
        referer = req.headers.referrer
      } else if (req.headers.referer) {
        referer = req.headers.referer
      }
    }

    // cookieのCAKEPHP取得
    let cookieCakePhp = this.$cookies.get('CAKEPHP')

    // ccuid、user-agent、ip、refererをstoreにセット
    commit('auth/SET_CCUID', ccuid)
    commit('auth/SET_USER_AGENT', ua)
    commit('auth/SET_CLIENT_IP', ip)
    commit('auth/SET_INITIAL_REFERER', referer)
    if (cookieCakePhp) {
      commit('auth/SET_CAKEPHP', cookieCakePhp)
    }

    const sessionKey = this.$cookies.get(process.env.config['session-key'])
    const businessSessionKey = this.$cookies.get(process.env.config['session-key-business'])
    const privateSessionKey = this.$cookies.get(process.env.config['session-key-private'])
    const isLocal = !!req.headers.host.match(/^localhost/)
    const sessionMaxAge = 60 * 60 * 24 * 365 * 10 // 10年
    // NOTE: ビジネスアカウントからの個人アカウント新規作成時、CAKEでの登録ページ遷移からブラウザバックをしたかどうか
    // または、ビジネスアカウントへの個人アカウント連携時、CAKEでのログインページ遷移からブラウザバックをしたかどうか
    const isBrowserBackWhenPrivateAccountLinking =
      !!businessSessionKey &&
      !privateSessionKey &&
      businessSessionKey !== sessionKey &&
      (!!query.is_private_creation || !!this.$cookies.get('is_account_link_in_progress'))
    const promises = [
      new Promise(async resolve => {
        const appsFlyerKey =
          this.$cookies.get(MEASURING_APP_INSTALL) || this.$util.genAppsFlyerKeyCookieVal(query)
        const appsFlyerUrl = await dispatch('apps_flyer_url/getAppsFlyerUrl', appsFlyerKey)
        // getAppsFlyerUrlの戻り値があった場合, 有効期限を更新する
        if (appsFlyerUrl) {
          this.$cookies.set(MEASURING_APP_INSTALL, appsFlyerKey, {
            path: '/',
            maxAge: 60 * 60 * 24 * 30 // 30日
          })
        }
        commit('auth/SET_APP_STORE_URL', appsFlyerUrl)
        resolve()
      }),
      new Promise((resolve, reject) => {
        const shouldDeleteSession = [
          '/business/register/invitation',
          '/business/register/email_verified',
          '/business/register/enter_information'
        ].includes(state.route.path)
        const token = (() => {
          if (shouldDeleteSession) {
            return null
          }
          // sessionキーのずれが発生した場合、本来のログインセッションをtokenに渡す
          if (isBrowserBackWhenPrivateAccountLinking) {
            return businessSessionKey
          }
          return sessionKey
        })()
        dispatch('auth/tryAuth', { token }, { root: true })
          .then(resolve)
          .catch(reject)
      }),
      new Promise((resolve, reject) => {
        dispatch('master/fetchBasic', null, { root: true })
          .then(resolve)
          .catch(reject)
      }),
      new Promise((resolve, reject) => {
        dispatch('pages/blogs/master/fetchBlogCategories', null, { root: true })
          .then(resolve)
          .catch(reject)
      })
    ]
    try {
      // NOTE: ビジネスアカウントからの個人アカウント新規作成時、CAKEでの登録ページ遷移からブラウザバックをした場合
      // sessionキーのずれが発生するため本来のログインセッションに書き換える。
      // business:○,private:×,coconala_session:△(ログインページ生成cookie) -> coconala_session = business
      if (isBrowserBackWhenPrivateAccountLinking) {
        this.$cookies.set(process.env.config['session-key'], businessSessionKey, {
          path: '/',
          domain: isLocal ? 'localhost' : '.coconala.com',
          httpOnly: true,
          secure: true,
          maxAge: sessionMaxAge
        })
        this.$cookies.set('CAKEPHP', businessSessionKey, {
          path: '/',
          domain: '',
          httpOnly: true,
          secure: true,
          maxAge: sessionMaxAge
        })
      }
      await Promise.all(promises)
      if (getters['auth/isLoggedIn']) {
        // SentryにユーザーIDを送る(SSR対応)
        this.$sentry.setUser({
          id: state.auth.user.id,
          ip_address: ip
        })

        // 種別に対応する個人/ビジネスのセッションキーがCookieに存在していない場合、メインのセッションキーの値をコピーして作成する
        if (state.auth.user.isBusiness && !businessSessionKey) {
          this.$cookies.set(process.env.config['session-key-business'], sessionKey, {
            path: '/',
            domain: isLocal ? 'localhost' : '.coconala.com',
            httpOnly: true,
            secure: true,
            maxAge: sessionMaxAge
          })
        }
        if (!state.auth.user.isBusiness && !privateSessionKey) {
          this.$cookies.set(process.env.config['session-key-private'], sessionKey, {
            path: '/',
            domain: isLocal ? 'localhost' : '.coconala.com',
            httpOnly: true,
            secure: true,
            maxAge: sessionMaxAge
          })
        }
        await dispatch('my/header/fetchAccountInfo')
      }
    } catch (grpcCode) {
      const statusCode = util.grpcCodeToHttpStatusCode(grpcCode)
      return error({
        statusCode,
        message: '',
        grpcCode
      })
    }

    // アンケート未回答のビジネスアカウントでの閲覧が許されるパス一覧
    // 未回答時にアクセスできる下記ホワイトリスト内の画面からNuxtLinkのCSR遷移を使うとリスト外の画面へ遷移できてしまうので、リストに画面を追加時には追加する画面内のリンクを確認・修正する
    // 背景: https://github.com/welself/coconala-web/pull/3358#issuecomment-1019957786
    const whiteList = [
      '/login',
      '/logout',
      '/business',
      '/business/', // スラッシュ付きが正式パス
      '/inquiry',
      '/pages/terms_user',
      '/pages/privacy',
      '/pages/tokushou',
      '/pages/terms_provider',
      '/pages/terms_exchange_point',
      '/pages/settlement',
      '/business/register/migration_completed',
      '/business/register/completed'
    ]
    if (state.auth.user.isBusiness && !whiteList.includes(state.route.path)) {
      try {
        await dispatch('pages/business/questionnaire/fetchAccount')
      } catch ({ grpcCode, statusCode }) {
        return error({
          statusCode,
          message: '',
          grpcCode
        })
      }
      if (!state.pages.business.questionnaire.account.businessUser.isQuestionnaireFinished) {
        return redirect('/business/register/welcome_back')
      }
    }

    const cookieSessionBusiness = this.$cookies.get(process.env.config['session-key-business'])
    const cookieSessionPrivate = this.$cookies.get(process.env.config['session-key-private'])
    const existsBusinessAccountInfo = !!Object.keys(state.my.header.businessAccountInfo).length
    const existsPrivateAccountInfo = !!Object.keys(state.my.header.privateAccountInfo).length
    /**
     * この処理を修正して動くようにした結果（https://github.com/welself/coconala-web/pull/2558）、他の処理に悪影響が出てきた（従来バグ前提で動いていた？）ので一旦コメントアウトして後ほど精査する
     * 議論スレッド: https://coconala.slack.com/archives/CFN0VC1GV/p1628405473154700?thread_ts=1628403815.148400&cid=CFN0VC1GV
     */
    // ビジネスアカウントの紐付きがないアカウントである、かつ、ビジネスセッションが存在する場合、Cookieからビジネス用セッションを削除
    // if (
    //   !existsBusinessAccountInfo &&
    //   cookieSessionBusiness &&
    //   !this.$cookies.get('is_account_link_in_progress')
    // ) {
    //   this.$cookies.remove(process.env.config['session-key-business'], {
    //     path: '/',
    //     domain: isLocal ? 'localhost' : '.coconala.com',
    //     httpOnly: true,
    //     secure: true
    //   })
    // }
    // 個人アカウントの紐付きがないアカウントである、かつ、個人セッションが存在する場合、Cookieから個人用セッションを削除
    // if (
    //   !existsPrivateAccountInfo &&
    //   cookieSessionPrivate &&
    //   !this.$cookies.get('is_account_link_in_progress')
    // ) {
    //   this.$cookies.remove(process.env.config['session-key-private'], {
    //     path: '/',
    //     domain: isLocal ? 'localhost' : '.coconala.com',
    //     httpOnly: true,
    //     secure: true
    //   })
    // }

    /**
     * "uid" query に応じた処理（主にメール内リンク押下時、uidでメール送信対象アカウントが指定されるため）
     * 参考設計 https://welself.atlassian.net/wiki/spaces/CD/pages/2702049684
     * @returns nuxtServerInit内で後続処理をするかどうか
     */
    const redirectByUid = async () => {
      const requestedUserId = Number(query.uid)
      if (typeof requestedUserId !== 'number' || isNaN(requestedUserId)) {
        return true
      }
      if (state.auth.user?.id === requestedUserId) {
        return true
      }
      try {
        // 指定されたIDのアカウントが存在するかを確認するためにリクエストしている
        await grpcClient({
          method: UserService.GetUser,
          request: new GetUserRequest().setUserId(requestedUserId),
          metadata: commonMetaData(state)
        })
      } catch {
        error({ statusCode: 403 })
        return false
      }
      if (!getters['auth/isLoggedIn']) {
        return true
      }
      const accounts = [state.my.header.businessAccountInfo, state.my.header.privateAccountInfo]
      const indexOfAnotherAccount = accounts.findIndex(account => account?.isCurrent === false)
      const anotherAccount = accounts[indexOfAnotherAccount]
      const isAnotherAccountForPrivate = indexOfAnotherAccount === 1
      if (anotherAccount?.userId !== requestedUserId) {
        error({ statusCode: 403 })
        return false
      }
      if (!anotherAccount.isLogin) {
        return true
      }
      const queryKeysToBeKept = Object.keys(query).filter(key => key !== 'uid')
      const queryStringToBeKept = queryKeysToBeKept.length
        ? '?' + queryKeysToBeKept.map(key => `${key}=${query[key]}`).join('&')
        : ''
      redirect({
        name: 'switch_account',
        query: {
          switch_for: isAnotherAccountForPrivate ? '1' : '2',
          redirect_to: (route.path === '/switch_account' ? '/' : route.path) + queryStringToBeKept
        }
      })
      return false
    }

    const continuesNuxtServerInit = await redirectByUid()
    if (!continuesNuxtServerInit) {
      return
    }
  }
}

export const mutations = {}
